import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { withRouter } from 'react-router';
import styled from 'styled-components';
import * as actions from '../actions';
import ProCard from './ProCard';
import List from '../../common/components/list/List';
import CardGroup from '../../common/components/ui/CardGroup';
import { media } from '../../common/components/ui/utils';
import reverse from 'lodash/reverse';
import withArea from '../../common/components/areaselect/withArea';
import InlineLoader from '../../common/components/inlineloader';

const PaddedContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 320px;
  padding-top: 2.5rem;
  ${media.tabletNarrow`
    max-width: calc(640px + 2rem);
  `} ${media.tabletWide`
    max-width: calc(960px + 5rem);
  `} margin: 0 auto;
`;

class ProsList extends Component {
  componentWillMount() {
    this.loadData();
  }

  loadData() {
    const { loadPros } = this.props;
    loadPros(); //.then();
  }

  handleLoadMoreClick = () => {
    this.props.loadPros(true);
  };

  renderPro = pro => {
    return <ProCard key={pro.id} {...pro} />;
  };
  
  render() {
    var { paginatedPros, isFetching } = this.props;
    if (this.props.lecturesFirst) {
      paginatedPros.sort((first, second) => {
        return first.services && first.services.length
          ? -1
          : second.services && second.services.length ? 1 : 0;
      });
    } else if (this.props.lecturesOnly) {
      paginatedPros = paginatedPros.filter(pro => {
        return pro.services && pro.services.length;
      });
    }

    if(isFetching){
      return <InlineLoader />
    }

    return (
      <PaddedContainer>
        <List
          Container={CardGroup}
          items={paginatedPros}
          renderItem={this.renderPro}
        />
      </PaddedContainer>
    );
  }
}

const isVisible = pro => {
  if ('hide_from_listings' in pro && pro.hide_from_listings){
    return false;
  } 
  return true;
}

const getAreaFilter = (state) => {
  const {
    area: {
      area,
    }
  } = state;
  return area;
}

const getPros = (state) => {
  const { entities: { pros }, pagination: { prosPaginated } } = state;
  const pagination = prosPaginated || { ids: [] };
  //const paginatedPros = pagination.ids.map(id => pros[id])
  const reversed = reverse(pagination.ids.slice());
  const paginatedPros = reversed.map(id => pros[id]).filter(isVisible).map(item => ({
      ...item,
      proAreas: item.area ? item.area.map(area => area.label) : []
    })
  );
  return paginatedPros
}

const getProsByArea = createSelector(
  [ getAreaFilter, getPros ],
  (areaFilter, pros) => {
    switch (areaFilter) {
      case 'finland':
      case undefined:
        return pros;
      default:
        return pros.filter(pro => pro.proAreas.includes(areaFilter))
    }
  }
)

const mapStateToProps = state => {
  const {
    pagination: {
      prosPaginated: {
        isFetching
      }
    },
    area: {
      area
    }
  } = state;
  return {
    isFetching,
    area,
    paginatedPros: getProsByArea(state),
  };
};

ProsList = withRouter(withArea(connect(mapStateToProps, actions)(ProsList)));

export default ProsList;



// WEBPACK FOOTER //
// ./src/modules/pros/components/ProsList.js